/* Number ops */

import Settings from "./settings";
import Storage from "./storage.service";
import HTTP from "./http.service";
import Globals from "./globals";
import Helpers from "./helpers";

var Products = {};

var once = false;

Products.get = function(setting) {
	return Products[setting];
};

Products.set = function(setting, val) {
	Products[setting] = val;
};

Products.saveCurrentProduct = () => {
	let config = {
		method: "get",
		url: "/products/current?save=true"
	};

	let f = HTTP(config);
	f
	.then(res => {
		if (res.data && res.data.product) {
			Products.selectProduct(res.data.product, "fff");
		}
	})
	.catch(err => {});
	return f;
};

Products.clear = () => {
	once = false;
};

Products.sortByCommitment = (a, b) => {
	return a.CommitmentDuration - b.CommitmentDuration;
};

Products.init = () => {

	if (!Storage.get("products")) {

		Products.getProducts()
		.then(products => {

			let payg_products = products.data.filter(product=>{
				return product['ProductCategory'] === 'PAYG';
			});

			let commitment_products = products.data.filter(product=>{
				return product['ProductCategory'] === 'Commitment';
			});

			commitment_products = commitment_products.sort(Products.sortByCommitment);

			Storage.setShared("payg_products", payg_products);

			Storage.setShared("commitment_products", commitment_products);

			Storage.setShared("products", products.data);

			if (!once) {
				once = true;
				Products.fetchCurrentProduct()
				.then(data => {
					if (data && data.data) {
						let product = null;
						if( data.data.product){
							product = data.data.product;
						} else {
							product = Products.getDefaultProduct(); 
						}

						Products.selectProduct(product, "77");

						let flags = Storage.get("flow_status_flags");
						let had_vip_and_lost_it = false;
						if(product && flags && !flags.is_number_selected && product["ProductCategory"] === "VIP"){
							had_vip_and_lost_it = true;
						}
						if(had_vip_and_lost_it){
							Products.saveProduct(Products.getDefaultProduct());
						}

					} 
				})
				.catch(error => {
					Globals.handleError(error, '46');
				});
			}
		})
		.catch(error => {
			if(error !== false){
				Globals.handleError(error, '47');
			}
		});
	} else {
		if(!Storage.get("selectedProduct")){
			let commitment_products = Storage.get("commitment_products");
			if (!once && commitment_products) {
				once = true;
				Products.fetchCurrentProduct()
				.then(data => {
					if (data && data.data) {
						if( data.data.product){
							Products.selectProduct(data.data.product);
						} else {
							Products.selectProduct(Products.getDefaultProduct());
						}
					} 
				})
				.catch(error => {
					Globals.handleError(error, '48');
				});
			}
		}
	}
};

Products.getProductByCode = (code) => {
	let products = Storage.get("commitment_products");
	for (let product of products) {
		if ("" + code === "" + product.ProductCode) {
			return product;
		}
	}
	return null;
}

Products.getProductByCommitment = (duration) => {
	let products = Storage.get("commitment_products");
	for (let product of products) {
		if ("" + duration === "" + product.CommitmentDuration) {
			return product;
		}
	}
	return null;
}

Products.selectProductByDuration = duration => {
	let products = Storage.get("commitment_products");
	let currentProduct = Products.getCurrentProductCommitment();

	if(duration !== currentProduct){
		for (let product of products) {
			if (duration === product.CommitmentDuration) {
				Helpers.log("Selecting product with commitment = " + duration);
				Products.selectProduct(product, "6");
				return;
			}
		}
	}
	Helpers.log("no product found with commitment =  " + duration);
};

Products.isCurrentProductUserSelected = () => {
	let flags = Storage.get("flow_status_flags");
	if (
		flags &&
		flags.is_product_selected &&
		flags.is_plan_selected &&
		!flags.has_vip
		) {
		Helpers.log("isCurrentProductUserSelected? Yes");
	return true;
}
	Helpers.log("isCurrentProductUserSelected? No");
	return false;
};

Products.selectProduct = (product, callee = null) => {
	Storage.set("selectedProduct", product);
};

Products.selectCommitmentProduct = () => {
	let selectedProduct = Storage.get("selectedProduct");
	if(selectedProduct){
		let products = Storage.get("commitment_products");
		for (let product of products) {
			if (product.ProductCode === selectedProduct.ProductCode) {
				return;
			}
		}
		Products.selectProduct(Products.getDefaultProduct());
	}
}

Products.getDefaultProduct = () => {
	let products = Storage.get("commitment_products");
	if (products){
		return products[2];
	}
	return null;
}

Products.getCurrentProduct = () => {
	let current = Storage.get("selectedProduct");
	if (current) {
		return current;
	}

	if (!current){
		return Products.getDefaultProduct();
	}

	return null;
};

Products.saveProduct = (product = null) => {
	let product_to_save = product? product: Storage.get("selectedProduct");
	let config = {
		method: "post",
		url: "/products/save",
		data: {
			product_code: product_to_save["ProductCode"]
		}
	};
	return HTTP(config);
};

Products.saveProductByProductCode = (code) => {
	let config = {
		method: "post",
		url: "/products/save",
		data: {
			product_code: code
		}
	};
	return HTTP(config);
};

Products.getMonthlyProduct = () => { 
	let products = Storage.get("products") || [];
	return products.find(c => c.CommitmentDuration === 1 && c.ProductCategory==='Commitment')
}

Products.saveDefaultProduct = () => {
	let product = Products.getProductByCommitment(12);
	if(product){
		return Products.saveProduct(product);
	}
	return Helpers.emptyReject();
}

Products.getCurrentProductCommitment = (current = null) => {
	let product = Products.getCurrentProduct();
	if (product) {
		return product.CommitmentDuration;
	} else {
		return 1;
	}
};

Products.fetchCurrentProduct = () => {
	let config = {
		method: "get",
		url: "/products/current"
	};
	return HTTP(config);
};

Products.fetchProducts = (categories = "Commitment,payg") => {
	if(Storage.get("fetching_products")){
		return Helpers.emptyReject();
	}
	Storage.set("fetching_products", true);

	let params = "";
	if (categories) {
		params = "?category=" + categories;
	}
	let config = {
		method: "get",
		url: "/products/available" + params
	};
	let f = HTTP(config);
	f.finally(()=>{
		Storage.clear("fetching_products");
	});
	return f;
};

Products.getVanityIds = () => {
	let vanities = Settings.vanity_map;
	return Object.keys(vanities);
}

Products.getVanities = () => {
	return Settings.vanity_map;
}

Products.getProducts = () => {
	let property = "Products";
	let prop = property.toLowerCase();
	if (Storage.get(prop)) {
		Helpers.log("found " + prop + " in storage.. ");
		let data = {
			data: Storage.get(prop)
		};
		return new Promise((resolve, reject) => {
			resolve(data);
		});
	} else {
		Helpers.log("fetching " + property + " from api..");
		let fetcher = Products["fetch" + property];
		return fetcher();
	}
};
Products.fetchAllowedFeatures = () => {
	Products.getCurrentProduct().then((data) => {
		if (data && data.data) {
			if (data.data.product) {
				Products.setAllowedFeatures(data.data.product);
			}
		}
	});
};
Products.setAllowedFeatures = (product) => {
	if (product && product.AllowedFeatures) {
		let features = [];
		for (let feature of product.AllowedFeatures) {
			features.push(feature.Code);
		}
		Storage.set("allowed_features", features);
	}
};
Products.isFeatureAllowed = (feature_code) => {
	let features = Storage.get("allowed_features") || [];
	return features.indexOf(feature_code) !== -1;
};

Products.isStarterPlan = () => {
	// starter plan has no yearly plans with same plan ids, 
	// find plan id, if no yearly plan match so it can't be upgraded or allowed for upsell
	let res = false;
	let selctedPlan = Storage.get("selectedCustomPlan");
	let plans = Storage.get("PlansbyProductCode");
	let productCodes = Storage.get("commitment_products");
	if (selctedPlan && plans && productCodes){
		let planIds = selctedPlan?.vmo_subplans_ids_sorted?.join(',');
		let yearlyProductCode = productCodes.find(c=>c.CommitmentDuration===12);
		let yearlyPlan = plans[yearlyProductCode?.ProductCode]?.vmo_packages?.[planIds];
		if (!yearlyPlan) res = true;
	}
	return res;
}

// this function only allow upsell if :
// product commitment 1 or 6 months, and
// plan is custom selected [not : VIP / PAYG / StarterPlan / minorPlan]
Products.allowProductUpsell = () => {
	let plansByProductCode = Storage.get("PlansbyProductCode") || [];
	// minors:
	if (Object.keys(plansByProductCode) === 1 && plansByProductCode[0]?.ProductCategory==='Commitment'){
		return false;
	}
	let product = Products.getCurrentProduct();
	let commitment = product?.CommitmentDuration;
	let category = product?.ProductCategory;
	// exclude starter plan from upsell,
	// because it has same category and commitment as 1 month custom plan
	return category === 'Commitment' && commitment !== 12 && !Products.isStarterPlan();
}

export default Products;